import { Navigate, useParams } from 'react-router-dom';

export function Redirect() {
	const { '*': url } = useParams();

	return <Navigate to={`/${url}`} replace />;
}
